export default __webpack_public_path__ + "static/media/programme-card-3.0d6bcd56.png";